'use client';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@v2/ui/Select';
import clsx from 'clsx';
import { useState } from 'react';

export enum HomeAwayEventsTypes {
  ALL = 'All games',
  HOME = 'Home',
  AWAY = 'Away',
}

interface Props {
  onTabChange: (tab: HomeAwayEventsTypes) => void;
  variant?: 'tabs' | 'dropdown' | 'responsive';
  value?: HomeAwayEventsTypes;
}

export const HomeAwayEventsTab = ({
  onTabChange,
  variant = 'tabs',
  value,
}: Props) => {
  const [activeTab, setActiveTab] = useState(HomeAwayEventsTypes.ALL);
  const selectedTab = value ?? activeTab;
  const buttonItemClassname = (isActive: boolean) =>
    clsx('text-gray-600 font-semibold px-3 h-10 rounded-lg', {
      'bg-gray-800 text-white': isActive,
    });

  const onTabClick = (tab: HomeAwayEventsTypes) => {
    if (value === undefined) setActiveTab(tab);
    onTabChange(tab);
  };

  const dropdown = (
    <Select
      value={selectedTab}
      onValueChange={(value) => onTabClick(value as HomeAwayEventsTypes)}
    >
      <SelectTrigger
        aria-label="Home & Away"
        className="h-11 min-w-0 gap-2 border-gray-200 bg-white px-3 py-0 text-sm text-gray-800 md:h-12 md:w-auto md:text-base"
      >
        <SelectValue>
          {selectedTab === HomeAwayEventsTypes.ALL
            ? 'Home & Away'
            : selectedTab}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={HomeAwayEventsTypes.ALL}>Home &amp; Away</SelectItem>
        <SelectItem value={HomeAwayEventsTypes.HOME}>Home</SelectItem>
        <SelectItem value={HomeAwayEventsTypes.AWAY}>Away</SelectItem>
      </SelectContent>
    </Select>
  );

  if (variant === 'dropdown') return dropdown;

  return (
    <div>
      {variant === 'responsive' && <div className="md:hidden">{dropdown}</div>}
      <div
        role="group"
        aria-label="Home & Away"
        className="hidden gap-x-2 rounded-lg border border-gray-200 p-1 md:flex"
      >
        <button
          type="button"
          aria-pressed={selectedTab === HomeAwayEventsTypes.ALL}
          onClick={() => onTabClick(HomeAwayEventsTypes.ALL)}
          className={buttonItemClassname(
            selectedTab === HomeAwayEventsTypes.ALL
          )}
        >
          {HomeAwayEventsTypes.ALL}
        </button>
        <button
          type="button"
          aria-pressed={selectedTab === HomeAwayEventsTypes.HOME}
          onClick={() => onTabClick(HomeAwayEventsTypes.HOME)}
          className={buttonItemClassname(
            selectedTab === HomeAwayEventsTypes.HOME
          )}
        >
          {HomeAwayEventsTypes.HOME}
        </button>
        <button
          type="button"
          aria-pressed={selectedTab === HomeAwayEventsTypes.AWAY}
          onClick={() => onTabClick(HomeAwayEventsTypes.AWAY)}
          className={buttonItemClassname(
            selectedTab === HomeAwayEventsTypes.AWAY
          )}
        >
          {HomeAwayEventsTypes.AWAY}
        </button>
      </div>
    </div>
  );
};
